import { Button, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react'
import StyledTableContainer from './StyledTableContainer';
import { useNavigate } from 'react-router-dom';
import route from '../Routes';


// Rows arrive pre-formatted from the API (formatCustReqData): name, location,
// load, loadType, preTruckTypes, shipCreated and c_at are display-ready strings.
function CustReqReptTable({ custReqData, columns }) {
    const navigate = useNavigate();

    return (
        <StyledTableContainer height={"83%"}>
            <TableHead>
                <TableRow>
                    {columns.map((column) => (
                        <TableCell
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            sx={{ color: "#8392AB", fontWeight: "bold", py: 1 }}
                            key={column.id}
                        >
                            {column.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {(custReqData || []).map((dataRow, index) => {
                    return (
                        <TableRow hover tabIndex={-1} key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                            {columns.map((column) => {
                                const value = dataRow[column.id];
                                return (
                                    (column.id === 'custReqId') ?
                                        <TableCell key={column.id} align={column.align}>
                                            <Button variant="text" sx={{ color: "#000000", textAlign: "left" }} onClick={() => { navigate(route.boCustReqInfo + dataRow.custReqId) }}>
                                                {value}
                                            </Button>
                                        </TableCell> : (column.id === "name") ?
                                            <TableCell key={column.id} align={column.align} sx={{ textAlign: "left" }}>
                                                <Button variant="text" sx={{ color: "#000000", textAlign: "left" }} onClick={() => { navigate(route.boCustInfo + dataRow.custId) }}>
                                                    {value}
                                                </Button>
                                            </TableCell> :
                                            <TableCell key={column.id} align={column.align} sx={{ textAlign: "left" }} >
                                                {value}
                                            </TableCell>);
                            })}
                        </TableRow>
                    );
                })}
            </TableBody>
        </StyledTableContainer>
    )
}

export default CustReqReptTable
